module.exports = __webpack_public_path__ + "img/00029.2c4f557d.webp";